import {reduxForm, Field, getFormValues} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar'
import SearchBar from 'components/Fields/ReduxForm/SearchBar'
import {ActionBarWrapper} from 'components/wrappers/pages'
import DropdownButtonSelectIcon from 'components/Fields/ReduxForm/DropdownButtonSelectIcon'
import {onChangeOutletIds, onChangeDate, onChangeKeyword, exportSummary, onChangeNamespace} from 'actions/inventory/summary'
import moment from 'moment'
import * as mpInvSummary from 'mixpanel/inventory/summary'
import styles from './ActionBar.css'

class ActionBar extends React.Component {
  static NAMESPACE_OPTIONS = [
    {
      id: 'items', name: 'Item Library'
    },
    {
      id: 'ingredients', name: 'Ingredients'
    }
  ]

  render () {
    let {outlets, isIngredientActive} = this.props
    return (<ActionBarWrapper>
      <div className='col-sm-10 col-xs-12' style={{paddingLeft: 0}}>
        <form className={`form-inline ${styles['action-bar']}`}>
          <div className='form-group mr-5px'>
            <Field
              name='outletIds'
              component={DropdownOutlet}
              outlets={outlets}
              onChangeOutletIds={this._onChangeOutletIds}
              allOutletOption
          />
          </div>
          <div className='form-group mr-5px'>
            <Field
              component={DropdownCalendar}
              name='date'
              onChange={this._onChangeDate}
              updateServerOnChange
          />
          </div>
          <div className='form-group mr-5px'>
            <Field
              component={DropdownButtonSelectIcon}
              name='namespace'
              options={ActionBar.NAMESPACE_OPTIONS}
              onChange={this._onChangeNamespace}
              disabled={!isIngredientActive}
            />
          </div>
          <div className='form-group mr-5px'>
            <Field
              component={SearchBar}
              name='keyword'
              onChange={this._onChangeKeyword}
              placeholder='Search'
            />
          </div>
        </form>
      </div>
      <div className='col-sm-2 hidden-xs' style={{paddingRight: 0}}>
        <span className='pull-right'>
          <button className='btn btn-primary' onClick={this._onClickExport}>
            Export
          </button>
        </span>
      </div>
    </ActionBarWrapper>)
  }

  /**
   * Redux form auto convert array to objects, so we change it back to array
   * @private
   * @param outletIdsAsObject
   */
  _onChangeOutletIds = (outletIds) => {
    const {dispatch, search: {date, namespace}} = this.props
    mpInvSummary.inventorySummaryChangeFilter({
      outletIds,
      startDate: date.startDate,
      endDate: date.endDate,
      namespace
    })
    dispatch(onChangeOutletIds(outletIds, date, namespace))
  };

  _onChangeDate = ({startDate, endDate}) => {
    const {dispatch, search: {keyword, namespace, outletIds}} = this.props
    mpInvSummary.inventorySummaryChangeFilter({
      outletIds,
      startDate: startDate,
      endDate: endDate,
      namespace
    })
    dispatch(onChangeDate({startDate, endDate}, keyword, namespace))
  };

  _onChangeKeyword = (event, keyword) => {
    const {dispatch, search: {date, namespace}} = this.props
    dispatch(onChangeKeyword(keyword, date, namespace))
  }

  _onClickExport = () => {
    let {search: {status, namespace, keyword, date: {startDate, endDate}, outletIds}, dispatch} = this.props
    let dateLabel = startDate.isSame(endDate, 'days') ? moment(startDate).format('DD-MM-YYYY') : [moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY')].join(' - ')
    let filename = 'Inventory Summary - ' + dateLabel

    dispatch(exportSummary({
      start_date: moment(startDate).format('D/M/YYYY'),
      end_date: moment(endDate).format('D/M/YYYY'),
      status: status,
      keyword: keyword,
      namespace
    }, filename, outletIds[0]))
  }

  _onChangeNamespace = (event, namespace) => {
    const {dispatch, search: {date: {startDate, endDate}, keyword, outletIds}} = this.props
    mpInvSummary.inventorySummaryChangeFilter({
      outletIds,
      startDate: startDate,
      endDate: endDate,
      namespace
    })
    dispatch(onChangeNamespace(namespace, {
      page: 1,
      start: startDate.format('D/M/Y'),
      end: endDate.format('D/M/Y'),
      keyword
    }))
  }
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  const {outlets} = state.inventory.summary
  const search = getFormValues('search')(state)
  const {subscriptionStatus: {is_active}} = state.inventory.ingredientSubscription
  return {outlets, search, isIngredientActive: is_active}
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Inventory/Summary/ActionBar/ActionBar.js